
import { authService } from './authService';
import { gamificationService } from './gamificationService';

export class StreakService {
  async updateStreak(userId: string): Promise<{
    streak: number;
    isNewStreak: boolean;
  }> {
    const user = await authService.getUserById(userId);
    if (!user) return { streak: 0, isNewStreak: false };
    
    const today = new Date().toISOString().split('T')[0];
    const lastActive = user.stats.lastActiveDate;
    
    if (lastActive === today) {
      // Already updated today
      return { streak: user.stats.streak, isNewStreak: false };
    }
    
    const yesterday = new Date(Date.now() - 24 * 60 * 60 * 1000)
      .toISOString()
      .split('T')[0];
    
    let newStreak: number;
    let isNewStreak = false;
    
    if (lastActive === yesterday) {
      // Continuing streak
      newStreak = user.stats.streak + 1;
      isNewStreak = true;
    } else {
      // Streak broken, reset to 1
      newStreak = 1;
    }
    
    await authService.updateUser(userId, {
      'stats.streak': newStreak,
      'stats.lastActiveDate': today
    });
    
    // Award XP for milestone streaks
    if (newStreak % 7 === 0) {
      await gamificationService.awardXP(userId, 'daily_streak');
    }
    
    if (isNewStreak) {
       window.dispatchEvent(new CustomEvent('streak-updated', { detail: { streak: newStreak } }));
    }
    
    return { streak: newStreak, isNewStreak };
  }
}

export const streakService = new StreakService();
